export interface GetDiagnosticsResponse {
  budibaseVersion: string
  hosting: string
  nodeVersion: string
  platform: string
  cpuArch: string
  cpuCores: number
  cpuInfo: string
  totalMemory: string
  uptime: string
}
